import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TitanIconButtonComponent } from 'src/app/user-interface/titan-icon-button/titan-icon-button';

@Component({
  selector: 'app-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TitanIconButtonComponent]
})
export class ChatInputComponent {
  @Input() value = '';
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();
  @Output() send = new EventEmitter<void>();

  onInputChange(value: string, event: Event) {
    this.value = value;
    this.valueChange.emit(value);

    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 160) + 'px';
  }

  onSend() {
    if (this.value.trim() && !this.disabled) {
      this.send.emit();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    // Ignore Enter while an IME composition is active (e.g. Japanese/Chinese/Korean
    // input): the user presses Enter to confirm a candidate conversion, not to send.
    // Submitting here would cut the message off mid-sentence. keyCode 229 is the
    // legacy signal for the same state. Let the event reach the IME untouched.
    if (event.isComposing || event.keyCode === 229) {
      return;
    }
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSend();
    }
  }
}
